export default __webpack_public_path__ + "images/25a87627979653790dad9b0fbe2cd126.svg";